"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.optionPropType = exports.multiPropType = exports.inputPropType = exports["default"] = exports.datePropType = exports.constraintPropType = exports.actionPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var optionPropType = _propTypes["default"].shape({
  key: _propTypes["default"].string,
  label: _propTypes["default"].string,
  active: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool
});
exports.optionPropType = optionPropType;
var constraintPropType = _propTypes["default"].shape({
  constraintType: _propTypes["default"].string,
  regex: _propTypes["default"].string,
  validationMessage: _propTypes["default"].string,
  displayFormat: _propTypes["default"].string
});
exports.constraintPropType = constraintPropType;
var multiPropType = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  fieldName: _propTypes["default"].string,
  fieldLabel: _propTypes["default"].string,
  isRequired: _propTypes["default"].bool,
  requiredMessage: _propTypes["default"].string,
  options: _propTypes["default"].arrayOf(optionPropType),
  type: _propTypes["default"].string,
  value: _propTypes["default"].string,
  helpMessage: _propTypes["default"].string,
  fieldLongDescription: _propTypes["default"].objectOf(_propTypes["default"].string)
});
exports.multiPropType = multiPropType;
var inputPropType = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  fieldName: _propTypes["default"].string,
  fieldLabel: _propTypes["default"].string,
  constraints: _propTypes["default"].arrayOf(constraintPropType),
  isRequired: _propTypes["default"].bool,
  requiredMessage: _propTypes["default"].string,
  numberOfLines: _propTypes["default"].number,
  value: _propTypes["default"].string,
  helpMessage: _propTypes["default"].string,
  usePlaceholder: _propTypes["default"].bool,
  hideTitle: _propTypes["default"].bool,
  type: _propTypes["default"].string
});
exports.inputPropType = inputPropType;
var datePropType = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  fieldName: _propTypes["default"].string,
  fieldLabel: _propTypes["default"].string,
  constraints: _propTypes["default"].arrayOf(constraintPropType),
  isRequired: _propTypes["default"].bool,
  requiredMessage: _propTypes["default"].string,
  numberOfLines: _propTypes["default"].number,
  value: _propTypes["default"].string,
  helpMessage: _propTypes["default"].string,
  usePlaceholder: _propTypes["default"].bool,
  hideTitle: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  previousLabel: _propTypes["default"].string,
  nextLabel: _propTypes["default"].string,
  weekStartDay: _propTypes["default"].number
});
exports.datePropType = datePropType;
var actionPropType = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  type: _propTypes["default"].string,
  name: _propTypes["default"].string,
  value: _propTypes["default"].string,
  label: _propTypes["default"].string
});
exports.actionPropType = actionPropType;
var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  leadFormType: _propTypes["default"].string,
  leadFormDescription: _propTypes["default"].string,
  thankYouPageURL: _propTypes["default"].string,
  formComponents: _propTypes["default"].arrayOf(multiPropType, inputPropType, datePropType, actionPropType),
  steps: _propTypes["default"].arrayOf(_propTypes["default"].any),
  backgroundColour: _propTypes["default"].string,
  formAlignment: _propTypes["default"].string,
  buttonAlignment: _propTypes["default"].string,
  showRecaptcha: _propTypes["default"].bool,
  recaptchaSiteKey: _propTypes["default"].string
});
var _default = PROP_TYPES;
exports["default"] = _default;